import React, { useRef } from "react";
import { message } from "antd";
import { useWarehouseModel } from "../warehouseModel";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils"
import { IVRMWarehouseInsert } from "../warehouseTypes";
import useGlobalModel from "@/model/globalModel";
import { debounce } from "lodash";

export function AddDetailDrawer() {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg])

    const { addWareVisible: visible, setAddWaerVisible, insertWarehouse } = useWarehouseModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setAddWaerVisible(false);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            insertWarehouse(res as IVRMWarehouseInsert).then(res => {
                res && onCancel()
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        formValues: { shopName: shopAndOrg.shopName },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属站点",
                fieldName: "shopName",
                span: 24,
                disable: true,

                // options: [{ label: "正常", value: "0" }, { label: "非正常", value: "9" }],
                // rules: [{ required: true, message: "请选择从属站点" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库编码",
                fieldName: "code",
                span: 24,
                // rules: [{ required: true, message: "请输入仓库编码" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库名称",
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: "请输入仓库名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "仓库负责人",
                fieldName: "contact",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系地址",
                fieldName: "address",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }
        ]
    };
    return (
        <YHDrawer
            {...{
                title: "仓库新增",
                visible,
                onCancel,
                okText: "保存",
                onOk: debounce(() => { onSubmit() }, 900)

            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
